export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/@ant-design/icons-react/es/index.js
// module id = 268
// module chunks = 0